import { QueryClient, useQuery } from '@tanstack/react-query';
import { UseQueryResult } from '@tanstack/react-query';
import { fetchListFlowItem } from '~/api/listFlow';
import { minutes30inMS } from '../../constants/times';
import { NextPageContext } from 'next';
import { RailsItem } from '~/typings/services/rails/item';
import { useAppSelector } from '~/store/store';
import { getListFlowItemId } from '~/store/listFlow/ui';

export function prefetchListFlowItem(
  ctx: NextPageContext,
  queryClient: QueryClient,
  itemId: number | string,
) {
  return queryClient.fetchQuery<RailsItem>(
    ['list-flow-item', itemId],
    () => fetchListFlowItem.call(ctx, itemId),
    {
      staleTime: minutes30inMS,
    },
  );
}

export function useListFlowItem(): UseQueryResult<RailsItem> {
  const id = useAppSelector(getListFlowItemId);
  return useQuery(['list-flow-item', id], () => fetchListFlowItem(id), {
    staleTime: minutes30inMS,
    enabled: !!id,
  });
}
